export default "/img/MA.ab3036e93d060239358854de330e0afe.png";